const actions = {
  getConsumo: async (
    context,
    {
      page,
      perPage,
      entrega_unidade_id,
      regiao,
      dataInicial,
      dataFinal,
      item,
      solicitante,
      centroCusto,
      epi,
      voucher_id,
      categoria_produto_codigo,
      grupo_produto_nome,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/ficha-epi/consumo`, {
      params: {
        entrega_unidade_id,
        page,
        perPage,
        regiao,
        dataInicial,
        dataFinal,
        item,
        solicitante,
        centroCusto,
        epi,
        voucher_id,
        categoria_produto_codigo,
        grupo_produto_nome,
      },
    });

    return res;
  },
  exportarConsumo: async (
    context,
    {
      page,
      perPage,
      entrega_unidade_id,
      regiao,
      dataInicial,
      dataFinal,
      item,
      solicitante,
      centroCusto,
      epi = "todos",
      voucher_id,
      simplificado,
      grupo_produto_nome,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/ficha-epi/consumo`, {
      params: {
        page,
        perPage,
        download: "excel",
        entrega_unidade_id,
        regiao,
        dataInicial,
        dataFinal,
        item,
        solicitante,
        centroCusto,
        epi,
        voucher_id,
        simplificado,
        grupo_produto_nome,
      },
    });

    return res;
  },

  exportarConsumoSimplificado: async (
    context,
    {
      vendor_id,
      regiao,
      initial_date,
      final_date,
      product,
      plantiff,
      cost_center,
      epi = "todos",
      voucher_id,
      simplificado,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/report/consumo-simplificado`, {
      params: {
        download: "excel",
        vendor_id,
        regiao,
        initial_date,
        final_date,
        product,
        plantiff,
        cost_center,
        epi,
        voucher_id,
        simplificado,
      },
    });

    return res;
  },

  getEstoque: async (
    context,
    { page, perPage, vendor_id, product_group, ordenar, product, saldo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vendors/reports/stock`, {
      params: {
        page,
        perPage,
        product_group,
        vendor_id,
        ordenar,
        product,
        saldo,
      },
    });

    return res;
  },

  exportarEstoque: async (
    context,
    { page, perPage, vendor_id, product_group, ordenar, saldo, product }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vendors/reports/stock`, {
      params: {
        page,
        perPage,
        download: "excel",
        vendor_id,
        product_group,
        ordenar,
        saldo,
        product,
      },
    });

    return res;
  },

  getEstoqueMovimento: async (
    context,
    { page, perPage, vendor_id = 1, produto_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let res = await api.get(`/inventory/report-inventory`, {
      params: {
        vendor_id,
        initial_date: "01/02/2001",
        type: "json",
        page,
        perPage,
        product_id: produto_id,
      },
    });

    return res;
  },

  getLotes: async (context, { vendor_id = 1, produto_id, remover_zerados }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let res = await api.get(`/vendors/reports/estoque-por-lote`, {
      params: {
        vendor_id,
        produto_id: produto_id,
        remover_zerados,
      },
    });

    return res;
  },

  exportarEstoqueMovimento: async (
    context,
    { page, perPage, vendor_id, produto_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/inventory/report-inventory`, {
      params: {
        page,
        perPage,
        download: "excel",
        initial_date: "01/02/2001",
        vendor_id,
        product_id: produto_id,
      },
    });

    return res;
  },

  getMasterData: async (
    context,
    {
      page,
      perPage,
      vendor_id,
      cost_center,
      cost_center_epi,
      user,
      status,
      desligado,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/auth/users/reports/master-data-v2`, {
      params: {
        page,
        perPage,
        type: "json",
        vendor_id,
        cost_center,
        cost_center_epi,
        user,
        status,
        desligado,
      },
    });

    return res;
  },

  exportarMasterData: async (
    context,
    { page, perPage, vendor_id, cost_center_epi, user, cost_center }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/auth/users/reports/master-data-v2`, {
      params: {
        download: "excel",
        initial_date: "01/02/2001",
        vendor_id,
        cost_center_epi,
        user,
        cost_center,
        page,
        perPage,
      },
    });

    return res;
  },

  getStatusTroca: async (
    context,
    {
      page,
      per_page,
      vendor_id,
      user,
      cost_center,
      functionn,
      product_group,
      search,
      status,
      regra_critica,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/product-groups/report`, {
      params: {
        page,
        per_page,
        vendor_id,
        user,
        cost_center,
        function: functionn,
        product_group,
        search,
        status,
        regra_critica,
      },
    });

    return res;
  },

  getStatusTrocaTopo: async (
    context,
    { vendor_id, pessoa, centro_custo, funcao, grupo, produto, regra_critica }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/indicador-seguranca-trabalho/highlights`, {
      params: {
        vendor_id,
        pessoa,
        centro_custo,
        funcao,
        grupo,
        produto,
        regra_critica,
      },
    });

    return res;
  },

  exportarStatusTroca: async (
    context,
    {
      page,
      per_page,
      vendor_id,
      user,
      cost_center,
      functionn,
      product_group,
      search,
      status,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/product-groups/report`, {
      params: {
        download: "excel",
        vendor_id,
        user,
        cost_center,
        functionn,
        product_group,
        search,
        status,
        page,
        per_page,
      },
    });

    return res;
  },

  getConsumoGrafico: async (context, { vendor, initial_date, final_date }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/consumo`, {
      params: {
        initial_date,
        final_date,
        vendor,
      },
    });

    return res;
  },

  getAtendimentosGrafico: async (
    context,
    { vendor, initial_date, final_date }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/numero-atendimentos`, {
      params: {
        initial_date,
        final_date,
        vendor,
      },
    });

    return res;
  },

  getTop10Funcionarios: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-funcionarios`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTop10FuncionariosPadrao: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-funcionarios`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTop10CentrosPadrao: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-cost-centers-name`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTop10CentrosPadraoNome: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-cost-centers`, {
      params: {
        initial_date,
        final_date,
        top,

        vendor,
      },
    });

    return res;
  },

  getTop10Produtos: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-produtos`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTop10Grupos: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-product-groups`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTop10Contas: async (
    context,
    { vendor, initial_date, final_date, top }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vouchers/analytics/top-contas`, {
      params: {
        initial_date,
        final_date,
        top,
        vendor,
      },
    });

    return res;
  },

  getTopoIndicadores: async (
    context,
    { vendor_id, initial_date, final_date }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/ficha-epi/consumo`, {
      params: {
        dataInicial: initial_date,
        dataFinal: final_date,

        entrega_unidade_id: vendor_id,
      },
    });

    return res;
  },

  getCompras: async (
    context,
    {
      page,
      search,
      vendor_id,
      compra_aberta,
      compra_sugerida,
      per_page,
      reposicao,
      stock,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vendors/${vendor_id}/products`, {
      params: {
        compra_aberta,
        compra_sugerida,
        per_page,
        reposicao,
        stock,
        page,
        search,
      },
    });
    return res;
  },

  alterarControla: async (context, { products, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(`/vendors/${vendor_id}/adjust-products`, {
      vendor_id,
      products,
    });
    return res;
  },

  alterarContrato: async (context, { product_id, contrato, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(`/products/${product_id}/contrato-fornecedor`, {
      product_id,
      vendor_id,
      contrato,
    });
    return res;
  },

  listarVerificacaoEstoqueLocalizado: async (
    context,
    { tratar, vendor_id, code, lote, per_page, page, download }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`verificacoes/lote-contra-total`, {
      params: {
        tratar,
        vendor_id,
        code,
        lote,
        per_page,
        page,
        download,
      },
    });

    return response;
  },

  forcarCalculoEstoqueLocalizado: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`verificacoes/forcar-lote-contra-total`);

    return response;
  },

  listarVerificacaoEstoque: async (
    context,
    { com_diferenca, vendor_id, code, per_page, page, download }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `verificacoes/movimentacao-contra-estoque-final`,
      {
        params: {
          com_diferenca,
          vendor_id,
          code,
          per_page,
          page,
          download,
        },
      }
    );

    return response;
  },

  forcarCalculoEstoque: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response =
      await api.get(`verificacoes/forcar-movimentacao-contra-estoque-final

`);

    return response;
  },
};

export const ind = {
  namespaced: true,
  actions,
};
